const mergeClasses = (...classes) =>
  classes.filter((className) => className).join(" ");

export default mergeClasses;
